export default "__VITE_ASSET__51395400__"